<script setup lang="ts">
import {Icon} from "@iconify/vue";

const semitones = defineModel<number>('semitones', {required: true, default: 0})

const {label = 'Intervall', disabled = false} = defineProps<{
  label?: string
  disabled?: boolean
}>()

function step(delta: number) {
  // Vue castet `<input type="number">` via `looseToNumber`: bei geleertem Feld bleibt der ROHE
  // String ('') im Model. `semitones.value += delta` wäre dann String-Konkatenation
  // ('' + 1 = '1', dann '11', '111') und der Wert ginge unverändert als `semitones` an
  // `POST /api/transpose`. Deshalb vor dem Rechnen numerisch normalisieren.
  const current = Number(semitones.value)
  semitones.value = (Number.isFinite(current) ? current : 0) + delta
}

function handleKeydown(event: KeyboardEvent) {
  if (event.key === 'ArrowUp') {
    event.preventDefault()
    step(1)
  } else if (event.key === 'ArrowDown') {
    event.preventDefault()
    step(-1)
  }
}
</script>

<template>
  <div class="flex flex-col flex-wrap flex-1 max-w-fit">
    <label class="block text-sm font-medium text-gray-700">
      {{ label }}
    </label>
    <div class="flex items-center min-w-fit gap-0 border rounded-xl border-gray-300 focus-within:border-blue-500 focus-within:ring-blue-500 ">
      <button class="rounded-full btn-glow-cyan-800 m-0 p-0  m-px p-1 border-0 max-w-min disabled:opacity-50" :disabled="disabled" @click="step(-1)">
        <Icon icon="fa6-solid:minus"/>
      </button>

      <input
          v-model.number="semitones"
          type="number"
          class="block h-16 border-0 outline-0  min-w-12 m-0 p-1 text-center max-w-24 flex-1 grow h-full rounded-md text-sm"
          :disabled="disabled"
          @keydown="handleKeydown"
      />

      <button class="rounded-full m-0 p-0  m-px p-1 btn-glow-cyan-800  border-0 max-w-min disabled:opacity-50" :disabled="disabled" @click="step(1)">

        <Icon icon="fa6-solid:plus"/>

      </button>
    </div>
    <div class="text-xs scale-90 font-normal text-gray-500">Halbtonschritte <strong>(HT)</strong></div>

  </div>
</template>

<style scoped>
@import "tailwindcss";
</style>
